var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoryBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_69895",
    "data-name": "Raggruppa 69895",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.984,
    height: 35.058,
    viewBox: "0 0 34.984 35.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2332.541,1293.963a17.583,17.583,0,0,1-8.245-2.055,1.21,1.21,0,0,1,1.14-2.135,15.2,15.2,0,0,0,10.552,1.38,1.21,1.21,0,0,1,.55,2.352A17.656,17.656,0,0,1,2332.541,1293.963Z",
    transform: "translate(-2315.086 -1258.904)",
    fill: "#222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M2323.24,1291.966a1.2,1.2,0,0,1-.831-.332,17.485,17.485,0,0,1-4.984-8.58,1.21,1.21,0,1,1,2.352-.57,15.068,15.068,0,0,0,4.3,7.4,1.21,1.21,0,0,1-.832,2.09Z",
    transform: "translate(-2317.006 -1261.379)",
    fill: "#222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M2318.314,1281.014h-.12a1.211,1.211,0,0,1-1.092-1.317v-.011a17.367,17.367,0,0,1,1.55-5.646,1.21,1.21,0,1,1,2.194,1.022,14.991,14.991,0,0,0-1.331,4.862A1.21,1.21,0,0,1,2318.314,1281.014Z",
    transform: "translate(-2317.097 -1263.899)",
    fill: "#222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M2322.2,1272.024a1.21,1.21,0,0,1-.934-1.977c.108-.132.218-.262.329-.389a1.212,1.212,0,0,1,1.83,1.589h0c-.1.11-.191.222-.284.336A1.212,1.212,0,0,1,2322.2,1272.024Z",
    transform: "translate(-2315.904 -1265.155)",
    fill: "#222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M2339.111,1298.865a1.21,1.21,0,0,1-.623-2.248,15.112,15.112,0,0,0-7.748-28.084,1.21,1.21,0,1,1,0-2.42,17.53,17.53,0,0,1,8.992,32.578A1.2,1.2,0,0,1,2339.111,1298.865Z",
    transform: "translate(-2313.285 -1266.114)",
    fill: "#222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M2340.536,1280.273h-6.925v-6.925h-2.432v6.925h-6.925v2.425h6.925v6.925h2.425V1282.7h6.925Z",
    transform: "translate(-2314.902 -1263.896)",
    fill: "#222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryBlack);
export default __webpack_public_path__ + "static/media/story-black.ecb928447d5113bbd4c5794e9efed110.svg";
export { ForwardRef as ReactComponent };